import { gql } from '@graphql/__generated__';
import type {
  Enquiries_Bool_Exp,
  Leads_Appraisal_Reason_Enum,
  TransactionCardFragment,
} from '@graphql/__generated__/graphql';

export const CONTACT_REQUEST_ENQUIRY_FRAGMENT = gql(/* GraphQL */ `
  fragment ContactRequestEnquiry on enquiries {
    id
    created_at
    first_name
    last_name
    email_address
    phone_number
    contact_reason
    message
    broker {
      full_name
    }
    team {
      name
    }
    property_transaction {
      ...TransactionCard
      property {
        country_code
        route
        street_number
        postcode
        locality
        living_surface
        built_surface
        number_of_rooms
      }
    }
  }
`);

export const excludeProfileLeadEnquiries = (
  where: Enquiries_Bool_Exp,
): Enquiries_Bool_Exp => ({
  _and: [where, { _not: { profile_lead_marker: {} } }],
});

export const getTeamContactRequestsWhere = (
  teamId: string,
): Enquiries_Bool_Exp =>
  excludeProfileLeadEnquiries({
    _or: [
      { broker: { teams_users: { team_id: { _eq: teamId } } } },
      { team_id: { _eq: teamId } },
    ],
  });

export type ContactRequest = {
  created_at: string;
  contact:
    | {
        full_name?: string | null;
        phone_numbers: { number: string }[];
        emails: { email: any }[];
      }
    | null
    | undefined;
  agent?: {
    full_name?: string | null;
  } | null;
  team?: {
    name: string;
  } | null;
  reason: Leads_Appraisal_Reason_Enum | string;
  property?: {
    country_code?: string | null;
    route?: string | null;
    street_number?: string | null;
    postcode?: string | null;
    locality?: string | null;
    living_surface?: number | null;
    built_surface?: number | null;
    number_of_rooms?: number | null;
    property_type?: {
      label?: string | null;
    } | null;
    land_surface?: number | null;
    latest_appraisal?: {
      min?: number | null;
      max?: number | null;
    } | null;
  } | null;
  message?: string | null;
  transaction?: TransactionCardFragment | null;
};

export { mapEnquiryToContactRequest } from '@modules/_shared/utils/mapEnquiryToContactRequest';
